export default __webpack_public_path__ + "static/media/LookOutTower.256.1973a7b6.png";